/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CodeEntry from "./CodeEntry";
import StringEntry from "./StringEntry";
import ArrayEntry from "./ArrayEntry";
import PeriodEntry from "./PeriodEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const displayStringFromFHIRAddress = (address) => {
  if (address === undefined || address === null || address === '') {
    return ""
  }
  if (typeof address === "object") {
    try {
      if (address.text) {
        return `${address.text}`;
      }
      let addressDisplay = "";
      if (address.line?.length > 0) {
        for (const lineItem of address.line) {
          addressDisplay = addressDisplay + lineItem + ", ";
        }
      }
      if (address.city) {
        addressDisplay = addressDisplay + address.city + ", ";
      }
      if (address.district) {
        addressDisplay = addressDisplay + address.district + ", ";
      }
      if (address.state) {
        addressDisplay = addressDisplay + address.state + ", ";
      }
      if (address.postalCode) {
        addressDisplay = addressDisplay + address.postalCode + ", ";
      }
      if (address.country) {
        addressDisplay = addressDisplay + address.country;
      }
      let addressDisplayLength = addressDisplay.length;
      if (addressDisplay.substring(addressDisplayLength - 2) === ", ") {
        addressDisplay = addressDisplay.substring(0, addressDisplayLength - 2);
      }
      if (addressDisplay && typeof addressDisplay === "string") {
        return addressDisplay;
      }
    } catch (e) { console.log(e); }
  }
  if (typeof address === "string") {
    return `${address} [ERROR: Address data not in expected Address datatype.]`
  }
  return "[ERROR: Address data not interpretable.]";
}

const addressDotUseValues = ["home", "work", "temp", "old", "billing"];
const addressDotTypeValues = ["postal", "physical", "both"];
const AddressEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

  const [addressState, setAddressState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingAddress = { "use": "", "type": "", "text": "", "line": [], "city": "", "district": "", "state": "", "postalCode": "", "country": "", "period": "" };
    if (startingValue) {
      if (startingValue.extension) { startingAddress.extension = startingValue.extension; }
      if (startingValue.use) { startingAddress.use = startingValue.use; }
      if (startingValue.type) { startingAddress.type = startingValue.type; }
      if (startingValue.text) { startingAddress.text = startingValue.text; }
      if (startingValue.line) { startingAddress.line = startingValue.line; }
      if (startingValue.city) { startingAddress.city = startingValue.city; }
      if (startingValue.district) { startingAddress.district = startingValue.district; }
      if (startingValue.state) { startingAddress.state = startingValue.state; }
      if (startingValue.postalCode) { startingAddress.postalCode = startingValue.postalCode; }
      if (startingValue.country) { startingAddress.country = startingValue.country; }
      if (startingValue.period) { startingAddress.period = startingValue.period; }
    }
    setAddressState(JSON.parse(JSON.stringify(startingAddress)));
  }, []);

  useEffect((() => {
    if (Object.keys(addressState).length) {
      let newAddress = {};
      if (addressState.extension) { newAddress.extension = addressState.extension; }
      if (addressState.use) { newAddress.use = addressState.use; }
      if (addressState.type) { newAddress.type = addressState.type; }
      if (addressState.text) { newAddress.text = addressState.text; }
      if (addressState.line !== null && addressState.line !== undefined &&
        Array.isArray(addressState.line) && addressState.line.length !== 0 &&
        !(addressState.line.length === 1 && addressState.line[0] === "")) {
        newAddress.line = addressState.line;
      }
      if (addressState.city) { newAddress.city = addressState.city; }
      if (addressState.district) { newAddress.district = addressState.district; }
      if (addressState.state) { newAddress.state = addressState.state; }
      if (addressState.postalCode) { newAddress.postalCode = addressState.postalCode; }
      if (addressState.country) { newAddress.country = addressState.country; }
      if (addressState.period && Object.keys(addressState.period).length) { newAddress.period = addressState.period; }
      if (Object.keys(newAddress).length === 0) {
        newAddress = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newAddress } });
    }
  }), [addressState]);

  if (startCollapsedState) {
    return <>
      <p>
        <b>{fieldLabel}: </b>
        {startingValue && displayStringFromFHIRAddress(startingValue)}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </p>
    </>
  } else if (Object.keys(addressState).length > 0) {
    return <div>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeEntry elementName='use' fieldLabel='Use'
          startingValue={addressState.use} setResourceState={setAddressState} dataEntryStyle='dropdown'
          allowedValues={addressDotUseValues} />
        <CodeEntry elementName='type' fieldLabel='Type'
          startingValue={addressState.type} setResourceState={setAddressState}
          allowedValues={addressDotTypeValues} />
        <StringEntry elementName='text' fieldLabel='Text'
          startingValue={addressState.text} setResourceState={setAddressState} />
        <ArrayEntry datatype='string' elementName='line'
          fieldLabel='Line' startingValue={addressState.line} setResourceState={setAddressState} />
        <StringEntry elementName='city' fieldLabel='City'
          startingValue={addressState.city} setResourceState={setAddressState} />
        <StringEntry elementName='district' fieldLabel='District'
          startingValue={addressState.district} setResourceState={setAddressState} />
        <StringEntry elementName='state' fieldLabel='State'
          startingValue={addressState.state} setResourceState={setAddressState} />
        <StringEntry elementName='postalCode' fieldLabel='Postal Code'
          startingValue={addressState.postalCode} setResourceState={setAddressState} />
        <StringEntry elementName='country' fieldLabel='Country'
          startingValue={addressState.country} setResourceState={setAddressState} />
        <PeriodEntry elementName='period' fieldLabel='Period' startCollapsed={true}
          startingValue={addressState.period} setResourceState={setAddressState} />
      </div>
    </div>
  }
};

export default AddressEntry;
export { displayStringFromFHIRAddress };